export default __webpack_public_path__ + "img/garagedoor_extended.ab9a2350d7dcba7be373fbd4a2c5340c.png";